<div class="container-fluid webView" style="padding-left: 10px;">
    <!-- Header -->
    <div class="col-12 col-sm-12 bgWhite webView" style="padding: {{stagemodalshow == true ? '15px 0px 0px 0px' : '15px 15px 0px 15px' }};">
        <div class="col-5 col-sm-5" style="padding: 0px; display: inline-block;vertical-align: middle;">
            <h3 class="newHeader" style="display: inline-block; font-size: 25px;">
                Stages
            </h3>
            <!-- <span *ngIf="!stagemodalshow" style="float: right;">
                <span class="label" (click)="open(AddStage,0)" title="Add New Stage"
                    style="border-radius: 50%; position: relative; top: 5px; cursor: pointer; bottom: 5px; padding: 10px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span> -->
           
        </div>
        <div class="col-md-7 col-sm-7" style="display: inline-block; text-align: right; padding: 0px;">
            <span *ngIf="stagemodalshow">
                <span class="label" (click)="open(AddStage,0)" title="Add New Stage"
                    style="border-radius: 50%; position: relative; top: 0px; cursor: pointer; bottom: 5px; padding: 9px; font-size: 11px; margin-right: 5px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span>
            <span *ngIf="stagemodalshow" class="closeMdl ng-scope" style="margin-right: 0%; padding: 5px 10px !important;"
                (click)="closeModel()">
                <i class="zmdi zmdi-close" title="Close" style="cursor:pointer;  position: relative; top: 0.5px;"></i>
            </span>
            <!-- <span  style="">
                <span class="btn btn-darkBlue" (click)="open(AddStage,0)" title="Add New Stage"
                    style="border-radius: 50%; position: relative; top: 5px; cursor: pointer; bottom: 5px; padding: 10px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span> -->
            <span *ngIf="!stagemodalshow" class="btn btn-orange brdrRadius3" (click)="open(AddStage,0)" title="Add New Stage"
            style="padding:4px 12px 4px;font-size:13px;line-height: 1.66em;"
            (click)="openEntryModal()">
                <span style="margin-right: 5px;"><i class="zmdi zmdi-plus"></i></span>
                <span> Add</span>
            </span>
            <span  *ngIf="!stagemodalshow" class="btn-darkBlue brdrRadius3" style="margin-left: 10px; font-size: 13px; display: inline-block; padding:4px 12px 4px; cursor: pointer;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> {{prTypeID == 2 ? 'Return to Projects' : 'Return to Production'}}
            </span>
        </div>
    </div>
    <div class="col-md-12" style="padding: {{stagemodalshow == true ? '0px' : '0px 15px' }};">
        <!-- Right -->
        <div class="col-md-12" style="padding: 15px 0px;">
            <!-- Right -->
            <div class="{{stagemodalshow == true ? 'col-md-12' : 'col-md-5' }} mainCardHeader inLneBlk" style="padding: 0px; vertical-align:middle;overflow: auto; height: {{stagemodalshow ? '350px' : ''}};">
                <div cdkDropList id="divScrID" class="col-md-12" style="padding: 0px;"
                    (cdkDropListDropped)="drop($event)">
                    <div *ngFor="let s of finalStages let i = index"
                        class="col-md-12 orangeBadge brdrRadius3"
                        style="margin-bottom: 10px; border: 1px solid #e88421; background-color: white;" cdkDrag>
                        <div class="row">
                            <div class="col-8" style="cursor: grab;">
                                <span style="font-size: 13px;">{{s.SNm}}</span>
                            </div>
                            <div class="col-4" style="text-align: right;display: inline-block;">
                                <div style="margin-right: 10px; font-size: 13px;display: inline-block;cursor: pointer;" title="Rearrange Stage" (cdkDropListDropped)="drop($event)">
                                    <i class="fa fa-bars"></i>
                                </div>
                                
                                <div class="lableBtnOrange" style="font-size: 13px;display: inline-block;cursor: pointer;" title="Edit"
                                    (click)="open(EditStage,s.SID)">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin: 0px;">
                            <div class="inLneBlk" *ngFor="let u of s.UIDs let j = index"
                                style="margin-bottom: 5px; color: #777; font-size: 12px;">
                                <span *ngIf="j == 0">
                                    <span>
                                        <i class="fa fa-circle"
                                            style="font-size: 10px; position: relative; top: -0.5px;"></i>
                                    </span>
                                    <span style="padding: 5px;">
                                        {{u.Name}}
                                    </span>
                                    <span *ngIf="s.UIDs.length != 1">
                                        <i class="fa fa-circle"
                                            style="font-size: 10px; position: relative; top: -0.5px;"></i>
                                    </span>
                                </span>
                                <span *ngIf="j != 0 && !(j == (s.UIDs.length-1))">
                                    <span style="padding: 5px;">
                                        {{u.Name}}
                                    </span>
                                    <i class="fa fa-circle"
                                        style="font-size: 10px; position: relative; top: -0.5px;"></i>
                                </span>
                                <span *ngIf="j == (s.UIDs.length-1)  && j != 0" style="padding: 5px;">
                                    {{u.Name}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bgWhite" style="padding-top: 15px;cursor:pointer;" *ngIf="finalStages.length == 0">
                    <div class="nrf brdrRadius3" (click)="open(AddStage,0)">
                        Click here to add a stage.
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="mobView pad0">
    <!-- Header -->
  <div class="col-md-12 bgWhite padHeder">
    <div class="col-md-12 col-12 col-sm-12 inLneBlk" style="padding-left: 0px; padding-right: 0px;">
      <span style="font-size: 20px; margin-right: 10px;" (click)="backBtn()">
        <i class="fa fa-chevron-left"></i>
      </span>
      <h4 class="newHeader" style="display: inline-block; padding-top: 6px;">Stages</h4>
      <span class="text-right">
        <span class="label brdrRadius3" (click)="open(AddStage,0)" style="float: right; right: 0px; top: 8px; position: relative;cursor: pointer; padding: 3px 9px; font-size: 11px; background: #e88421 !important; color: #fff !important ">
          <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 16px;
          margin-right: 8px;"></i> <span style="font-family: inherit; font-size: 17px;">Add</span>
        </span>
      </span>
      
    </div>
    </div>

    <!-- Body -->

    <div class="col-md-12" style="padding: 0px;">
      <!-- Right -->
      <div class="col-md-6 mainCardHeader inLneBlk" style="vertical-align: top;">
        <div cdkDropList id="divScrID" class="col-md-12" style="padding: 0px;" (cdkDropListDropped)="drop($event)">
          <div *ngFor="let s of finalStages let i = index"
               class="col-md-12 orangeBadge brdrRadius3 orangeBrdr bgWhite"style="margin-bottom: 5px;margin-bottom: 10px; background: white !important;">
            <div class="row">
              <div class="col-9" style="padding: 0px 0px 5px 15px;">
                <span style="font-size: 13px;">{{s.SNm}}</span>
              </div>
              <div class="col-3" style="padding-left: 0px; text-align: right;">
                <div cdkDrag style="padding-right: 10px; font-size: 13px;display: inline-block;" title="Drag & Drop" (cdkDropListDropped)="drop($event)">
                  <i class="fa fa-bars"></i>
                </div>
                <div style="margin-right: 4px; font-size: 13px;display: inline-block;" title="Edit"
                     (click)="open(EditStage,s.SID)">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <div class="row" style="margin: 0px;">
              <div class="inLneBlk" *ngFor="let u of s.UIDs let j = index"
                   style="margin-bottom: 5px; color: #777; font-size: 12px;">
                <span *ngIf="j == 0">
                  <span>
                    <i class="fa fa-circle"
                       style="font-size: 6px; position: relative; top: -2.5px;"></i>
                  </span>
                  <span style="padding: 5px;">
                    {{u.Name}}
                  </span>
                  <span *ngIf="s.UIDs.length != 1">
                    <i class="fa fa-circle"
                       style="font-size: 6px; position: relative; top: -2.5px;"></i>
                  </span>
                </span>
                <span *ngIf="j != 0 && !(j == (s.UIDs.length-1))">
                  <span style="padding: 5px;">
                    {{u.Name}}
                  </span>
                  <i class="fa fa-circle" style="font-size: 6px; position: relative; top: -2.5px;"></i>
                </span>
                <span *ngIf="j == (s.UIDs.length-1)  && j != 0" style="padding: 5px;">
                  {{u.Name}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="bgWhite" style="padding-top: 15px;" *ngIf="finalStages.length == 0">
          <div class="nrf" (click)="open(AddStage,0)" style="margin-left: 15px;">
            Click here to add a stage.
          </div>
        </div>
      </div>
    </div>

  </div>
<!--Add stage-->
<ng-template #AddStage let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr" style="font-size: 22px;">Add Stage</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close " title="Close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 10px 15px 15px 15px;">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px;">
                <input type="text" class="form-control" [(ngModel)]="newStage.stageName" maxlength="50"
                    style="text-indent: 2px; " placeholder="Enter Stage" captalize-first>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-4 col-sm-4 col-xs-6" *ngFor="let u of rights let i = index"
                style="display: inline-block; margin-bottom: 10px;padding: 5px 0px; font-size: 13px;">
                <!-- <input type="checkbox" [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked" style="vertical-align: middle;">
                <span style="margin-left: 5px;">{{u.Name}}</span> -->
                 <label style="margin-left: 5px; cursor: pointer;">
                    <input type="checkbox" class="chkbox-darkblue"  [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked" 
                    style="cursor: pointer; margin-right: 5px; position: relative; top: 2px;">{{u.Name}}
                </label> 
            </div>
            
        </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span class="btn-green brdrRadius3" style="padding: 0px 10px; font-size: 14px; line-height: 30px;" (click)="addStage(newStage.stageName,rights)">
                <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
</ng-template>


<!--Edit stage-->
<ng-template #EditStage let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr" style="font-size: 22px;">Edit Stage</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" title="Close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 10px 15px 15px 15px;display: inline-block;">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px;display: inline-block;">
                <input type="text" class="form-control" [(ngModel)]="stage" maxlength="50" style="text-indent: 2px;"
                    placeholder="Enter Stage" captalize-first>
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-6 col-6" *ngFor="let u of editRights let i = index"
                style="display: inline-block; margin-bottom: 10px;padding: 5px 0px; font-size: 13px;">                
                <label style="margin-left: 5px; cursor: pointer;">
                    <input type="checkbox" class="chkbox-darkblue"  [disabled]="u.IsDisabled" [(ngModel)]="u.isChecked" 
                    style="cursor: pointer; margin-right: 5px; position: relative; top: 2px;">{{u.Name}}
                </label> 
            </div>
        </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span class="btn-green brdrRadius3" style="padding: 0px 10px; font-size: 14px; line-height: 30px;" (click)="editStage(stage,editRights)">
                <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
</ng-template>
